export const SCREEN_NAME = {
  COMPANY_DETAILS: 'company_details',
  VERIFY_YOUR_COMPANY: 'verify_your_company',
} as const;

export const EVENT_NAME = {
  COMPANY_VIEWED: 'company_viewed',
  PROFILE_PAGE_SIGN_UP_FLOW: 'profile_page_sign_up_flow',
  SCREEN_SHOWN: 'screen_shown',
} as const;

export const STARTING_POINT = {
  VERIFY_YOUR_COMPANY: 'Verifiera ditt företag',
  ADD_WEBSITE: 'Lägg till hemsida',
  ADD_EMAIL: 'Lägg till e-post',
  ADD_PHONE: 'Lägg till telefon',
  ADD_ADDRESS: 'Lägg till besöksaddress',
  ADD_SERVICE: 'Lägg till tjänst',
  NEW_CUSTOMER_MODAL: 'Ny kund modal',
} as const;

export const UNVERIFIED_SUBSCRIPTION_TYPE = 'non_verified_profile_page';

export const SIGN_UP_STARTING_POINT = 'signup_initiated';
